import { Box, Flex, Text } from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import { useChartTheme } from '../../../hooks/useChartTheme'
import { brand } from '../../../theme'

const MotionBox = motion.create(Box)

interface ChartCardProps {
  title: string
  subtitle?: string
  detailPath?: string
  delay?: number
  children: React.ReactNode
}

export default function ChartCard({ title, subtitle, detailPath, delay = 0, children }: ChartCardProps) {
  const { card, colors } = useChartTheme()
  const navigate = useNavigate()

  return (
    <MotionBox
      bg={card.bg}
      backdropFilter={card.backdropFilter}
      border="1px solid"
      borderColor={card.border}
      borderRadius="2xl"
      overflow="hidden"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      boxShadow={card.boxShadow}
    >
      <Flex p={6} justifyContent="space-between" alignItems="flex-start" borderBottom="1px solid" borderColor={card.border}>
        <Box>
          <Text fontSize="lg" fontWeight="bold" color={colors.text}>
            {title}
          </Text>
          {subtitle && (
            <Text fontSize="10px" textTransform="uppercase" letterSpacing="0.2em" fontWeight="bold" color={colors.textMuted} mt={1}>
              {subtitle}
            </Text>
          )}
        </Box>
        {detailPath && (
          <Text
            fontSize="10px"
            textTransform="uppercase"
            letterSpacing="0.2em"
            fontWeight="bold"
            color={brand.green}
            cursor="pointer"
            _hover={{ textDecoration: 'underline' }}
            onClick={() => navigate(detailPath)}
          >
            Ver Detalle
          </Text>
        )}
      </Flex>
      <Box p={6}>{children}</Box>
    </MotionBox>
  )
}
